import { createElement } from 'react';
import { itemIcon } from './item-icon';

/** Renders an item's icon (decorative). */
export function ItemIcon({
  item,
  className,
}: {
  item: Parameters<typeof itemIcon>[0];
  className?: string;
}) {
  return createElement(itemIcon(item), { className, 'aria-hidden': true });
}
